import { render, staticRenderFns } from "./EnquiryViaPhoneStatItem.vue?vue&type=template&id=24e1c1b2&"
import script from "./EnquiryViaPhoneStatItem.vue?vue&type=script&lang=js&"
export * from "./EnquiryViaPhoneStatItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports